import { type ReactElement } from 'react';
import { Modal } from '@optimization/ssi-common';
import TermsOfUseContent from './terms-of-use-content';
import styles from './style.module.scss';

interface TermsOfUseModalProperties {
  readonly onClose: () => void;
}

const TermsOfUseModal = ({ onClose }: TermsOfUseModalProperties): ReactElement => (
  <Modal header="Guidelines" size="md" variant="primary" onClose={onClose}>
    <TermsOfUseContent className={styles['modal-content']} />
  </Modal>
);

export default TermsOfUseModal;
